import styled from "styled-components";

export const GalleryContainer = styled.div`
    display: flex;
    gap: 16px;
    overflow-x: auto;
`;

export const ImageWrapper = styled.div`
    width: 120px;
    height: 120px;
    border-radius: 8px;
    border: 1px solid #E5E9F0;
    overflow: hidden;
    flex-shrink: 0;
    cursor: pointer;
`;

export const Thumbnail = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
`;

export const EmptyText = styled.span`
    font-size: 14px;
    color: #6A7181;
`;

export const PreviewOverlay = styled.div`
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.8);
    z-index: 1100;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const PreviewImage = styled.img`
    max-width: 90vw;
    max-height: 80vh;
    object-fit: contain;
    user-select: none;
`;

export const PreviewCloseButton = styled.button`
    position: absolute;
    top: 20px;
    right: 20px;
    background: rgba(0, 0, 0, 0.4);
    border: none;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background 0.2s;

    &:hover {
        background: rgba(255, 255, 255, 0.15);
    }
`;

export const PreviewCounter = styled.div`
    position: absolute;
    top: 24px;
    left: 50%;
    transform: translateX(-50%);
    color: #FFFFFF;
    font-size: 14px;
    background: rgba(0, 0, 0, 0.4);
    padding: 6px 14px;
    border-radius: 100px;
`;

export const PreviewNavButton = styled.button`
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    ${({ position }) => position === 'left' ? 'left: 20px;' : 'right: 20px;'}
    background: rgba(0, 0, 0, 0.4);
    border: none;
    border-radius: 50%;
    width: 48px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background 0.2s;

    &:hover {
        background: rgba(255, 255, 255, 0.15);
    }
`;

export const PreviewToolbar = styled.div`
    position: absolute;
    bottom: 32px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 16px;
    background: rgba(0, 0, 0, 0.55);
    border-radius: 100px;

    button {
        background: transparent;
        border: none;
        padding: 8px;
        cursor: pointer;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        transition: background 0.2s;

        &:hover {
            background: rgba(255, 255, 255, 0.15);
        }
    }
`;